import type { IBadgeLabel } from './BadgeLabel';

import BadgeLabel from './BadgeLabel';

export type { IBadgeLabel };
export default BadgeLabel;
